import React from 'react';

const SearchFlightPanel1 = () => {
    // This component should contain the state and logic for the flight search form.
    // For this example, it's just the UI.
    return (
        // Using Bootstrap's form and grid classes for layout
        <div>
            {/* Oneway/Roundtrip Tabs */}
            <ul className="nav nav-pills nav-fill mb-4">
                <li className="nav-item">
                    <a className="nav-link active" href="#">ONEWAY</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href="#">ROUNDTRIP</a>
                </li>
            </ul>

            <div className="row g-3">
                <div className="col-md-3">
                    <label className="form-label">FROM</label>
                    <input type="text" className="form-control form-control-lg" defaultValue="Hyderabad (HYD), India" />
                </div>
                <div className="col-md-3">
                    <label className="form-label">TO</label>
                    <input type="text" className="form-control form-control-lg" defaultValue="Mumbai (BOM), India" />
                </div>
                <div className="col-md-2">
                    <label className="form-label">DEPARTURE DATE</label>
                    <input type="text" className="form-control form-control-lg" defaultValue="16-Oct-2025" />
                </div>
                <div className="col-md-2">
                    <label className="form-label">TRAVELLERS & CLASS</label>
                    <input type="text" className="form-control form-control-lg" defaultValue="1 Adults, 0 Kids..." />
                </div>
                <div className="col-md-2 d-flex align-items-end">
                    <button className="btn btn-primary btn-lg w-100">SEARCH</button>
                </div>
            </div>

            <div className="mt-3 d-flex gap-4">
                <div className="form-check">
                    <input className="form-check-input" type="radio" name="flightType" id="regular" defaultChecked />
                    <label className="form-check-label" htmlFor="regular">REGULAR</label>
                </div>
                {/* ... other radio buttons ... */}
            </div>
        </div>
    );
};

export default SearchFlightPanel1;